import { AnimatePresence, motion } from 'motion/react';

interface NavigationProps {
	children: React.ReactNode;
	keyProp: string;
	center?: boolean;
}

export default function Navigation({ children, keyProp, center = false }: NavigationProps) {
	return (
		<AnimatePresence initial={false} mode="wait">
			<motion.nav
				key={keyProp}
				className={`booking__navigation ${center ? 'booking__navigation--center' : ''}`}
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				exit={{ opacity: 0 }}
				transition={{ duration: 0.375 / 2 }}
			>
				{children}
			</motion.nav>
		</AnimatePresence>
	);
}
